import { render } from "./SimpleSaleDetailView.vue?vue&type=template&id=c8eedc4e&scoped=true"
import script from "./SimpleSaleDetailView.vue?vue&type=script&lang=js"
export * from "./SimpleSaleDetailView.vue?vue&type=script&lang=js"

import "./SimpleSaleDetailView.vue?vue&type=style&index=0&id=c8eedc4e&lang=css"
import "./SimpleSaleDetailView.vue?vue&type=style&index=1&id=c8eedc4e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8eedc4e"]])

export default __exports__